<template>
    <el-table
      :data="optionsData"
      border
      height="324"
      :cell-class-name="tableCellClassName"
      :header-cell-class-name="tableHeaderCellClassName"
      style="width: 1200px"
      >
      <!-- <el-table-column
        prop="cassName"
        label="Cass级平台名称"
        width="180">
      </el-table-column> -->
      <el-table-column
        type="index"
        label="序号"
        width="60">
      </el-table-column>
      <el-table-column
        v-for="(opt,ind) in options"
        :key="ind"
        :prop="opt.prop"
        :label="opt.label"
        :width="opt.width"
        :sTyle="opt.sTyle"
        >
      </el-table-column>
      <!-- <el-table-column
        prop="version"
        label="版本号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="professionType"
        label="项目"
        width="100">
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="planStarttime"
        label="计划开始时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="planEndtime"
        label="计划结束时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="计划结束时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="degreeType"
        label="重要程度"
        width="100">
      </el-table-column>
      <el-table-column
        prop="projectManage"
        label="项目经理"
        width="100">
      </el-table-column>
      <el-table-column
        prop="status"
        label="目前状态"
        width="100">
      </el-table-column> -->
    </el-table>
</template>
<script>
export default {
    props:{
        options:{
          require:true,
          type:Array
        },
        optionsData:{
          require:true,
          type:Array
        }
    },
    methods:{
      tableHeaderCellClassName({columnIndex}){
   
        if(columnIndex==0){
          return 'black'
        }else if(columnIndex==1){
          return 'red'
        }else{
          return 'blue'
        }
      },
      tableCellClassName({row, columnIndex}){
        if(columnIndex==1){
          if(row.state=='已结束'){
              return 'delay'
          }
        }
        return '';
      }
    }
}
</script>

<style>
/* 表格head样式 */
.black-center .el-table th.red >.cell{color: red}
.black-center .el-table th.blue > .cell{color: #2f8eed}
.black-center .el-table th.black > .cell{color:#333}
.black-center .el-table .el-table__row .ordinary{color: red;}
.black-center .el-table .el-table__row .delay{color: #FB8405;}
.el-table .cell{line-height: 23px;}
.el-table td, .el-table th{padding: 2px 0;}

</style>



// WEBPACK FOOTER //
// src/components/floorBlock/table.vue